import React from "react";
import { Link } from "react-router-dom";

const ListCard = ({ list }) => {
  return (
    <Link to={`/lists/${list.lid}`} className="list-card">
      <h2 className="list-card-title">{list.title}</h2>
      <img
        className="list-card-img"
        src={list.poster}
        alt={list.title}
      />
    </Link>
  );
};


export default ListCard;
